/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import PurposeContainer from './purpose/container/PurposeContainer';
import AmountContainer from './amount/container/BasicAmountContainer';

function PSASettingsContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/mcro/settings/birth/amount"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('psa/settings/birth/amount') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Basic Amount
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/mcro/settings/birth/purpose"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('psa/settings/birth/purpose') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Purpose
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="card p-0">
          <Switch>
            <Route
              path={`${match.path}/birth/purpose`}
              component={PurposeContainer}
            />
            <Route
              path={`${match.path}/birth/amount`}
              component={AmountContainer}
            />
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/birth/amount`} />}
            />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}

PSASettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(PSASettingsContainer);
